import { gql } from '@apollo/client';

export const GET_MITARBEITER_PERSONAL_IDS = gql`
  query mitarbeiter_getMitarbeiterPersonalIds($standortId: String!) {
    Anlageassistent_getMitarbeiterPersonalIds(standortId: $standortId) {
      e2nIdMitarbeiter {
        id
        vorname
        nachname
        e2nId
      }
      personalnummernMitarbeiter {
        id
        vorname
        nachname
        personalnummer
      }
    }
  }
`;
